import { useEffect, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { toast } from 'sonner';
import { API_URL } from '../lib/config';

export function AuthCallbackPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;

    const token = params.get('token');
    const error = params.get('error');

    if (error || !token) {
      toast.error('GitHub login failed. Please try again.');
      navigate('/login', { replace: true });
      return;
    }

    localStorage.setItem('cp_token', token);

    fetch(`${API_URL}/auth/me`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(r => r.json())
      .then(data => {
        if (data.success) {
          localStorage.setItem('cp_user', JSON.stringify(data.data.user));
          toast.success(`Welcome, ${data.data.user.name}!`);
        }
        navigate('/dashboard', { replace: true });
      })
      .catch(() => {
        navigate('/dashboard', { replace: true });
      });
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: 'var(--s0)' }}>
      <div className="flex flex-col items-center gap-4">
        <div
          className="w-8 h-8 rounded-full animate-spin"
          style={{ border: '2px solid var(--b-default)', borderTopColor: 'var(--brand)' }}
        />
        <p className="text-sm text-t3">Signing you in…</p>
      </div>
    </div>
  );
}
